/* Nocturnal Racing — shared theme JS */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    // Compact sticky header — slides in after scrolling past the hero (homepage)
    var mini = document.getElementById('miniHeader');
    if (mini) {
      var onScrollMini = function () {
        if (window.pageYOffset > window.innerHeight * 0.6) {
          mini.classList.add('is-visible');
        } else {
          mini.classList.remove('is-visible');
        }
      };
      window.addEventListener('scroll', onScrollMini, { passive: true });
      onScrollMini();
    }

    // ===== Cart drawer =====
    var drawer = document.getElementById('cartDrawer');
    var drawerBody = document.getElementById('cartDrawerBody');
    var drawerFoot = document.getElementById('cartDrawerFoot');
    var drawerTotal = document.getElementById('cartDrawerTotal');

    function nrMoney(c) { return '$' + (c / 100).toFixed(2); }
    function updateCounts(n) { document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = n; }); }
    function openCart() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('nr-noscroll'); } }
    function closeCart() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('nr-noscroll'); } }

    function renderCart(cart) {
      updateCounts(cart.item_count);
      if (!drawerBody) { return; }
      if (!cart.items || cart.item_count === 0) {
        drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn">Shop All</a></div>';
        if (drawerFoot) { drawerFoot.hidden = true; }
        return;
      }
      var h = '';
      cart.items.forEach(function (it) {
        var img = it.image ? '<img class="cart-drawer__img" src="' + it.image + '" alt="">' : '<div class="cart-drawer__img"></div>';
        var variant = (it.variant_title && it.variant_title.indexOf('Default') < 0) ? '<div class="cart-drawer__variant">' + it.variant_title + '</div>' : '';
        h += '<div class="cart-drawer__item" data-key="' + it.key + '">' + img +
          '<div><a class="cart-drawer__name" href="' + it.url + '">' + it.product_title + '</a>' + variant +
          '<div class="cart-drawer__row"><div class="cart-drawer__qty">' +
          '<button type="button" data-dec aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button type="button" data-inc aria-label="Increase">+</button>' +
          '</div><span class="cart-drawer__price">' + nrMoney(it.final_line_price) + '</span></div>' +
          '<button type="button" class="cart-drawer__remove" data-remove>Remove</button></div></div>';
      });
      drawerBody.innerHTML = h;
      if (drawerTotal) { drawerTotal.textContent = nrMoney(cart.total_price); }
      if (drawerFoot) { drawerFoot.hidden = false; }
    }

    function fetchCart(cb) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); if (cb) { cb(cart); } });
    }

    window.nrAddToCart = function (id, quantity, onDone) {
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { fetchCart(function () { openCart(); if (onDone) { onDone(true); } }); })
        .catch(function () { if (onDone) { onDone(false); } });
    };

    function changeQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
    }

    if (drawer && drawerBody) {
      document.querySelectorAll('[data-cart-open]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); fetchCart(); openCart(); });
      });
      document.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); } });
      drawerBody.addEventListener('click', function (e) {
        var item = e.target.closest('.cart-drawer__item');
        if (!item) { return; }
        var key = item.getAttribute('data-key');
        var qtyEl = item.querySelector('.cart-drawer__qty span');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (e.target.closest('[data-inc]')) { changeQty(key, qty + 1); }
        else if (e.target.closest('[data-dec]')) { changeQty(key, Math.max(0, qty - 1)); }
        else if (e.target.closest('[data-remove]')) { changeQty(key, 0); }
      });
      fetchCart();
    }

    // ===== Quick add from product cards =====
    document.querySelectorAll('.card__add[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        if (!id) { return; }
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        window.nrAddToCart(id, 1, function (ok) {
          btn.textContent = ok ? 'Added ✓' : 'Try again';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
        });
      });
    });

    // ===== Product page add-to-cart -> open drawer =====
    var pform = document.getElementById('product-form');
    if (pform) {
      pform.addEventListener('submit', function (e) {
        e.preventDefault();
        var idEl = pform.querySelector('[name="id"]');
        if (!idEl) { pform.submit(); return; }
        var qtyEl = pform.querySelector('[name="quantity"]');
        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        var addBtn = pform.querySelector('[name="add"]');
        var label = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
        window.nrAddToCart(idEl.value, qty, function (ok) {
          if (addBtn) { addBtn.textContent = ok ? 'Added ✓' : 'Try again'; setTimeout(function () { addBtn.textContent = label; addBtn.disabled = false; }, 1500); }
        });
      });
    }

    // ===== Email capture popup =====
    var popup = document.getElementById('emailPopup');
    if (popup) {
      var seen = false;
      try { seen = localStorage.getItem('nr_popup_seen') === '1'; } catch (err) {}
      function openPopup() { popup.classList.add('is-open'); popup.setAttribute('aria-hidden', 'false'); }
      function closePopup() { popup.classList.remove('is-open'); popup.setAttribute('aria-hidden', 'true'); try { localStorage.setItem('nr_popup_seen', '1'); } catch (err) {} }
      popup.querySelectorAll('[data-popup-close]').forEach(function (el) { el.addEventListener('click', closePopup); });
      if (popup.querySelector('.popup__success')) { openPopup(); try { localStorage.setItem('nr_popup_seen', '1'); } catch (err) {} }
      else if (!seen) { setTimeout(openPopup, 6000); }
    }

    // Mobile hamburger menu
    var burger = document.getElementById('burger');
    var menu = document.getElementById('mobileMenu');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        var open = menu.classList.toggle('open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          menu.classList.remove('open');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    }

    // Product gallery — thumbnails, arrows, and click-to-advance
    var mainImg = document.querySelector('[data-product-main]');
    if (mainImg) {
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-product-thumb]'));
      var images = thumbs.map(function (t) { return t.getAttribute('data-full'); });
      var index = 0;
      var AUTO_MS = 4500;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoTimer;
      function startAuto() { if (!reduceMotion && images.length > 1) { autoTimer = setInterval(function () { show(index + 1, 'next'); }, AUTO_MS); } }
      function stopAuto() { clearInterval(autoTimer); }
      function resetAuto() { stopAuto(); startAuto(); }

      function show(i, dir) {
        if (!images.length) { return; }
        index = (i + images.length) % images.length; // wrap around
        mainImg.src = images[index];
        // re-trigger the slide animation
        mainImg.classList.remove('is-next', 'is-prev');
        void mainImg.offsetWidth; // force reflow so the animation restarts
        mainImg.classList.add(dir === 'prev' ? 'is-prev' : 'is-next');
        thumbs.forEach(function (x, n) { x.classList.toggle('is-active', n === index); });
        resetAuto();
      }

      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () { show(n, n < index ? 'prev' : 'next'); });
      });

      var prev = document.querySelector('[data-gallery-prev]');
      var next = document.querySelector('[data-gallery-next]');
      if (next) { next.addEventListener('click', function (e) { e.preventDefault(); show(index + 1, 'next'); }); }
      if (prev) { prev.addEventListener('click', function (e) { e.preventDefault(); show(index - 1, 'prev'); }); }

      // Click the image itself to advance to the next one
      if (images.length > 1) {
        mainImg.addEventListener('click', function () { show(index + 1, 'next'); });
      }

      // Pause auto-play on hover, resume on leave
      var stage = mainImg.closest('.product__stage') || mainImg.parentNode;
      if (stage) {
        stage.addEventListener('mouseenter', stopAuto);
        stage.addEventListener('mouseleave', startAuto);
      }

      // Start the slideshow
      startAuto();
    }
  });
})();
